import { createContextHook } from '@/utils';
import { MagicContext } from '../MagicContext';

export const useMagic = createContextHook(MagicContext);
